import { Layers, PIXEL_SIZE } from './shared'

export const tilesets = {
  // FORMAT:
  // terrain: {
  //   url: '/assets/terrain.set.png',
  //   presets: {
  //     // Key is the preset name. loc: [cx, cy] is optional — sets where the triangle
  //     // indicator appears in the editor grid. cell/cells are the functional tile data.
  //
  //     // Plain cell
  //     grass: { loc: [0, 0], cell: [0, 0], layer: Layers.TERRAIN },
  //
  //     // With collider
  //     cliffWall: { loc: [2, 1], cell: [2, 1], layer: Layers.OVERLAY, collider: { ox: 0, oy: 0, w: 16, h: 16 } },
  //
  //     // Animated plain tile
  //     lava: { loc: [0, 7], cells: [[0, 7], [1, 7], [2, 7]], fps: 3, layer: Layers.TERRAIN },
  //
  //     // Autotile — cell is the top-left of a 2×3 block; self-connects with same-preset neighbours.
  //     dirtGrass: { loc: [0, 1], type: 'autotile', cell: [0, 1], layer: Layers.TERRAIN },
  //
  //     // Preset with no loc — no triangle shown in the editor grid
  //     hidden: { type: 'autotile', cell: [0, 4], layer: Layers.TERRAIN },
  //   },
  // },
  terrain: {
    url: '/assets/terrain.set.png',
    presets: {
      // grass: { loc: [0, 0], cell: [0, 0], layer: Layers.TERRAIN },
      // dirt: { loc: [1, 0], cell: [1, 0], layer: Layers.TERRAIN },
      // water: { loc: [2, 0], cell: [2, 0], layer: Layers.TERRAIN },
      dirtGrass: { type: 'autotile', loc: [0, 1], cell: [0, 1], layer: Layers.TERRAIN },
      waterGrass: {
        type: 'autotile',
        loc: [2, 1],
        cell: [2, 1],
        layer: Layers.TERRAIN,
        collider: { ox: -8 * PIXEL_SIZE, oy: 0, w: 16 * PIXEL_SIZE, h: 16 * PIXEL_SIZE },
      },
      mudDirt: { type: 'autotile', loc: [4, 1], cell: [4, 1], layer: Layers.TERRAIN },
      grassThicket: { type: 'autotile', loc: [6, 1], cell: [6, 1], layer: Layers.TERRAIN },
      longGrass: {
        loc: [1, 4],
        cells: [
          [1, 4],
          [2, 4],
          [3, 4],
        ],
        layer: Layers.DECOR,
        fps: 1,
      },
      blocker: {
        loc: [7, 0],
        cell: [7, 0],
        layer: Layers.OVERLAY,
        collider: { ox: -8 * PIXEL_SIZE, oy: 0, w: 16 * PIXEL_SIZE, h: 16 * PIXEL_SIZE },
      },
    },
  },
  foo: {},
}

export function getTilesetDef(id) {
  return tilesets[id] || null
}

export function getTilesetDefByUrl(url) {
  return Object.values(tilesets).find(def => def.url === url) || null
}

// Normalise preset cell definitions — always returns [[cx,cy], ...]
export function resolvePresetCells(preset) {
  if (preset.cells) return preset.cells
  if (preset.cell) return [preset.cell]
  return []
}

// ── Atlas key helpers ──────────────────────────────────────────────────────

// Single cell key (backward-compatible)
export function tilesetCellKey(tilesetId, cx, cy) {
  return `ts:${tilesetId}@${cx},${cy}`
}

// Multi-frame key — cells is [[cx,cy], ...]
export function tilesetKey(tilesetId, cells) {
  return `ts:${tilesetId}@${cells.map(c => c.join(',')).join(';')}`
}

// Parse either format — always returns { tilesetId, cells, cx, cy }
export function parseTilesetCellKey(key) {
  if (typeof key !== 'string' || !key.startsWith('ts:')) return null
  const rest = key.slice(3)
  const at = rest.indexOf('@')
  if (at === -1) return null
  const tilesetId = rest.slice(0, at)
  const cells = rest
    .slice(at + 1)
    .split(';')
    .map(part => part.split(',').map(Number))
  if (cells.some(([cx, cy]) => isNaN(cx) || isNaN(cy))) return null
  return { tilesetId, cells, cx: cells[0][0], cy: cells[0][1] }
}
